/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

export const MESSAGE_SERVER_ENDPOINT = 'Server Endpoint: {serverEndpoint}';
export const MESSAGE_GETTING_PAGE_RESPONSE = 'Getting Page Response for: {pageUrl}';
export const MESSAGE_CREATE_INPUT_LOADDATA = 'Created input for data actions $0 in $1-$2';
export const MESSAGE_NO_MOCK_FOUND = 'No mock path found from query';
export const MESSAGE_NO_SERVER_ENDPOINT_SET =
    'No server endpoint provided in .env file to lookup url. Please use a page mock or set MSDyn365_HOST in the .env file.';
export const MESSAGE_OVERRIDE_MODULE_CONFIG = 'Overriding module data property $0 with $1 for module $2';
export const MESSAGE_NEWCHILDPROP = 'Adding new child property $0 in $1 for module $2';
export const MESSAGE_INVALIDJSONPATH = 'Invalid JSON path, could not create new property in $0 for module $1';
export const MESSAGE_MULTIPLE_REND_CONTEXTS = 'Multiple RenderingContexts found across module mocks, only the first will be used';
export const MESSAGE_MOCKSNOTFOUND = 'Unable to find module mocks. Please ensure module mocks exist for the following mocks $0.';
export const MESSAGE_RS_CALL_ARGUMENTS = `Server-side retail call [m:{method}; e:{endPoint};v:{vector};r:{requestId}]`;
export const MESSAGE_DEBUG_MODULE_SSR_ERROR =
    'To debug the error further, please add debug=true query param to the page url to get more verbose debug information on the page.';
